import {Request} from './Request';
import {ResetType} from '../enums/reset.type.enum';

export class ResetRequest implements Request {
    chargePointSelectList: string[];
    private resetType: ResetType;

    constructor(chargePointSelectList: string[], resetType?: ResetType) {
        this.resetType = resetType;
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `ResetRequest (resetType: ${this.resetType},
        chargePointSelectList: ${this.chargePointSelectList})`;
    }


    get reset_type(): ResetType {
        return this.resetType;
    }

    set reset_type(value: ResetType) {
        this.resetType = value;
    }
}
